/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, IconButton, Grid, Stepper, Step, StepButton, StepLabel } from '@material-ui/core'
import { Clear } from '@material-ui/icons'

import CreateWorkflow from './Components/CreateWorkflow';
import SetWorkflowParameters from './Components/SetWorkFlowParameters';
import FinishWorkflowSetup from './Components/FinishWorkflowSetup';
import SetIUnFieldMaps from './Components/SetIUnFieldMaps';
import AddBots from './Components/AddBots'
import SubscribeEvents from './Components/SubscribeEvents'
import SetWFDataMarkers from "./Components/SetWFDataMarkers"
import SetFieldMaps from './Components/SetFieldMaps';
const styles = theme => ({

})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        // primary: {
        //     main: "#FF6600",  
        //     contrastText: "#FFFFFFFF"
        // },
        secondary: {
          main: '#ff9100',
        },
      },
})

function getSteps() {
    return ['Create Workflow', 'Set Information Units',  'Set Field Maps','Set Workflow Parameters', 'Finish Workflow Setup' ];
}

class AddWorkFlow extends Component {
    state = {
        activeStep : 0,
        steps : ['Create Workflow'],
        wf_name :  null,
        content_height : null,
        ic_name : null,
        wf_type : ''
    }

    componentWillMount () {
        //console.log('WF Name: ', this.props.wf_name)
        if (this.props.wf_name !== null) {
            this.setState({...this.state, wf_name : this.props.wf_name, activeStep : 1})
        }
    }

    head = React.createRef()
    dialog = React.createRef()

    componentDidMount () {
        const headHeight = this.head.current.clientHeight
        const dialogHeight = this.dialog.current.clientHeight
        const contentHeight = dialogHeight - headHeight

        //console.log('Dialog Content Height : ', contentHeight)
        this.setState({...this.state, content_height : contentHeight})
    }

    componentDidUpdate (prevProps, prevState) {
        if (prevState.wf_type !== this.state.wf_type) {
            console.log("WF Type Changed")
            this.setState({
                ...this.state,
                steps : this.getSteps()
            })
        }   
    }

    getSteps = () => {
        if (this.state.wf_type === "Process") {
            return ['Create Workflow', 'Set Information Units',  'Set Field Maps', 'Set Data Markers', 'Set Workflow Parameters', 'Finish Workflow Setup' ]
        } else if (this.state.wf_type === "Action") {
            return ['Create Workflow', 'Set Information Units',  'Set Field Maps', 'Set Data Markers', 'Set Workflow Parameters', 'Subscribe to Events', 'Add Scripts','Finish Workflow Setup' ]
        } else {
            return [ 'Create Workflow' ]
        }
    }
    
    handleStep = (step) => {
        this.setState({...this.state, activeStep : step})
    }

    handleNext = (obj) => {
        
        this.setState({...this.state, 
            activeStep : this.state.activeStep === this.state.steps.length - 1 && this.state.activeStep !== 0 ? -1 : this.state.activeStep + 1,
            ...obj
        }, () => {
            if (this.state.activeStep === - 1) {
                this.closingPopUp()
            }
        })
    };
    
    handleBack = () => {
        this.setState({...this.state, activeStep : this.state.activeStep === 0 ? this.state.activeStep : this.state.activeStep - 1})
    };

    renderStep = (step) => {
        switch (step) {
            case 'Create Workflow':
                return (
                    //<CreateIU ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>
                    <CreateWorkflow wf_name = {this.state.wf_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} closePopup={this.closingPopUp}/>
                )
            
            case 'Set Information Units': 
                return (
                    <SetIUnFieldMaps wf_name = {this.state.wf_name} ic_name = {this.state.ic_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} closePopup={this.closingPopUp}/>
                )
            
            case 'Set Field Maps':
                return (
                    <SetFieldMaps wf_name = {this.state.wf_name} ic_name = {this.state.ic_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} closePopup={this.closingPopUp}/>
                )

            case 'Set Data Markers': 
                return (
                    <SetWFDataMarkers wf_name = {this.state.wf_name} ic_name = {this.state.ic_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} closePopup={this.closingPopUp}/>
                )

            case 'Set Workflow Parameters':
                return (
                    //<SetAccessDetails ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>
                    <SetWorkflowParameters wf_name={this.state.wf_name} ic_name = {this.state.ic_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} closePopup={this.closingPopUp}/>
                )

            case 'Finish Workflow Setup':
                return (
                    <FinishWorkflowSetup wf_name={this.state.wf_name} ic_name = {this.state.ic_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} closePopup={this.closingPopUp}/>
                )

            case 'Subscribe to Events' :
                return (
                    <SubscribeEvents wf_name={this.state.wf_name} ic_name = {this.state.ic_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} closePopup={this.closingPopUp}/>
                ) 
                
            case 'Add Scripts' :
                return (
                    <AddBots wf_name={this.state.wf_name} ic_name = {this.state.ic_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} closePopup={this.closingPopUp}/>
                ) 
            default:
                 return 'Unknown Step'
         }
    }

    closingPopUp = () => {
        this.setState({...this.state, activeStep : 0})
        this.props.close()
    }


    render() {
        const { classes } = this.props
        return (
            
            <Paper ref = {this.dialog} style = {{width : '85vw', height : '85vh'}}>
                <div ref = {this.head} style = {{width : '100%'}}>
                    <div style = {{display : 'flex', flexDirection : 'row', padding : '8px'}}>
                        <Typography style = {{ flexGrow : 1}} variant = 'h6'>Adding Workflow <em>{this.state.wf_name}</em></Typography>
                        <IconButton size = 'small' color = 'secondary' onClick = {this.closingPopUp}>
                            <Clear/>
                        </IconButton>
                    </div> 
                    <Divider/>
                    <ThemeProvider theme = {blue_theme}>
                        <Stepper nonLinear style = {{width : '100%'}} activeStep={this.state.activeStep} alternativeLabel>
                            {this.state.steps.map((label, i) => (
                                <Step key={label}>
                                    <StepButton 
                                        onClick = {() => this.handleStep(i)}
                                    >
                                        {label}
                                    </StepButton>
                                </Step>
                            ))}
                        </Stepper>
                    </ThemeProvider>
                    <Divider/>
                </div>
                <Grid style = {{height : this.state.content_height }}  container>
                    {this.renderStep(this.getSteps(this.state.wf_type)[this.state.activeStep])}
                </Grid>
            </Paper>
        );
    }
}

export default withStyles(styles)(AddWorkFlow);